import { JSEncrypt } from 'jsencrypt';
export function loginApi(params) {
  const jsencrypt = new JSEncrypt();
  jsencrypt.setPublicKey(process.env.VUE_APP_PUBLIC_KEY);
  return usePost('/login', jsencrypt.encrypt(JSON.stringify(params)), {
    token: false,
    customDev: false,
    loading: false
  });
}
export async function tenantApi() {
  return useGet('/loginTenant');
}